import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isLogin } from "../../lib/constant";
import { toast } from "react-toastify";
import "./Drawer.css";

function Drawer({ navigationData, action, drawer }) {
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const navigate = useNavigate();

  const toggleSubmenu = (menuId) => {
    setOpenSubmenu(openSubmenu === menuId ? null : menuId);
  };

  const logOutClicked = async (e) => {
    e.preventDefault();
    localStorage.removeItem("is_authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    isLogin();
    navigate("/");
    toast("Logout Successfully", { type: "success" });
    action(e);
  };

  const handleLinkClick = (e) => {
    action(e);
  };

  const menuItems = [
    { id: 1, title: "Home", link: "/", icon: "far fa-home" },
    { id: 2, title: "Products", link: "/products", icon: "far fa-box" },
    { id: 3, title: "Draws", link: "/draws", icon: "far fa-ticket-alt" },
    { id: 4, title: "Winners", link: "/winner-list", icon: "far fa-trophy" },
    { id: 5, title: "Cart", link: "/cart", icon: "far fa-shopping-cart", requiresAuth: true },
  ];

  return (
    <>
      {/* Backdrop Overlay */}
      <div
        className={`dp-drawer-overlay ${drawer ? "active" : ""}`}
        onClick={action}
      />

      {/* Drawer Panel */}
      <div className={`dp-drawer ${drawer ? "active" : ""}`}>
        {/* Drawer Header */}
        <div className="dp-drawer-header">
          <Link to="/" className="dp-drawer-logo" onClick={handleLinkClick}>
            <img
              src={require(`../../assets/images/dream-prize.jpeg`).default}
              alt="DreamPrize"
            />
          </Link>
          <button className="dp-drawer-close" onClick={action} aria-label="Close menu">
            <i className="fal fa-times"></i>
          </button>
        </div>

        {/* Drawer Body */}
        <div className="dp-drawer-body">
          {/* Navigation Menu */}
          <ul className="dp-drawer-nav">
            {menuItems.map((item) => {
              if (item.requiresAuth && !isLogin()) return null;

              return (
                <li key={item.id} className="dp-drawer-nav-item">
                  <Link
                    to={item.link}
                    className="dp-drawer-nav-link"
                    onClick={handleLinkClick}
                  >
                    <span>
                      <i className={item.icon}></i>
                      {item.title}
                    </span>
                  </Link>
                </li>
              );
            })}

            {/* Account Menu with Submenu */}
            {isLogin() && (
              <li className={`dp-drawer-nav-item ${openSubmenu === "account" ? "open" : ""}`}>
                <div
                  className="dp-drawer-nav-link"
                  onClick={() => toggleSubmenu("account")}
                >
                  <span>
                    <i className="far fa-user-circle"></i>
                    My Account
                  </span>
                  <i className="far fa-chevron-right arrow"></i>
                </div>
                <ul className="dp-drawer-submenu">
                  <li>
                    <Link to="/wallet" onClick={handleLinkClick}>
                      <i className="far fa-wallet"></i> Wallet
                    </Link>
                  </li>
                  <li>
                    <Link to="/account-detail" onClick={handleLinkClick}>
                      <i className="far fa-cog"></i> Account Settings
                    </Link>
                  </li>
                </ul>
              </li>
            )}
          </ul>

          {/* User Section (if logged in) */}
          {isLogin() && (
            <div className="dp-drawer-user">
              <div className="dp-drawer-user-info">
                <div className="dp-drawer-avatar">
                  <i className="far fa-user"></i>
                </div>
                <div className="dp-drawer-user-details">
                  <h4>Welcome!</h4>
                  <p>Manage your account</p>
                </div>
              </div>
              <button className="dp-drawer-logout" onClick={logOutClicked}>
                <i className="far fa-sign-out"></i>
                Log Out
              </button>
            </div>
          )}

          {/* Auth Buttons (if not logged in) */}
          {!isLogin() && (
            <div className="dp-drawer-auth">
              <Link to="/login" className="dp-drawer-auth-btn primary" onClick={handleLinkClick}>
                <i className="far fa-sign-in"></i>
                Login
              </Link>
              <Link to="/register" className="dp-drawer-auth-btn secondary" onClick={handleLinkClick}>
                <i className="far fa-user-plus"></i>
                Create Account
              </Link>
            </div>
          )}
        </div>

        {/* Drawer Footer */}
        <div className="dp-drawer-footer">
          <div className="dp-drawer-social">
            <a href="#" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <p>© {new Date().getFullYear()} DreamPrize</p>
        </div>
      </div>
    </>
  );
}

export default Drawer;
